import React, { Suspense } from 'react'
import { SplitButton } from "@progress/kendo-react-buttons";
import { ChatApi } from '../../redux/api/ChatApi';
import userManager from '../../settings/oAuthSettings';

export default function ProfileImage() {
    const { data: userProfile } = ChatApi.useGetProfileQuery();
    if (!userProfile) return <></>

    return (

        <SplitButton className='profile-image-button-small'
            imageUrl={
                userProfile.Profile_Image_Url?.indexOf("/images") === 0
                    ? process.env.PUBLIC_URL + userProfile.Profile_Image_Url
                    : userProfile.Profile_Image_Url
            }
            items={[{ text: "Logout" }]}
            fillMode={"flat"}
            //onButtonClick={(e) => {
            //handleProfileClick()
            //unfocus
            // e.target.setState(s => {
            //   return { ...s, focused: false }
            // });
            //}}            
            onItemClick={(e) => {
                console.log('handleOnClick', e.item);
                //unfocus
                //   e.target.setState(s => {
                //     return { ...s, focused: false }
                //   });
                //const navItem: NavItems = e.item as NavItems;
                //handleOnClick(e.item?.Url);
                userManager.signoutRedirect();
            }} />

    )
}
